import { Link } from "react-router-dom";
import { FaRobot } from "react-icons/fa"; // ← NEW

function Navbar() {
  return (
    <nav className="fixed w-full top-0 bg-slate-800 text-white px-8 py-4 flex justify-between items-center z-50 shadow-lg">
      <h1 className="text-2xl font-bold text-cyan-400">
        LearnHubAI 🚀
      </h1>

      <div className="flex gap-6 items-center">
        <Link to="/" className="hover:text-cyan-400">
          Home
        </Link>

        <Link to="/blogs" className="hover:text-cyan-400">
          Blogs
        </Link>

        {/* ── NEW: AI Assistant link ── */}
        <Link
          to="/ai-assistant"
          className="flex items-center gap-2 px-4 py-2 bg-cyan-500 hover:bg-cyan-400 text-black font-semibold rounded-xl transition duration-300 hover:scale-105"
        >
          <FaRobot />
          AI Assistant
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;